import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { viewerMessages } from './viewerMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the viewer; each part uses its own slice of it */
import styles from './AssetViewer.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ViewerConfirmDialogProps {
  isBusy: boolean;
  onKeep: () => void;
  onTurnOff: () => void;
}

/**
 * "Turn off the link?" (design a3). It draws inside the viewer, so the focus trap of the viewer
 * holds it, and Esc closes it before the viewer (`useViewerKeys`).
 */
const ViewerConfirmDialogComponent: React.FC<ViewerConfirmDialogProps> = ({ isBusy, onKeep, onTurnOff }) => {
  const intl = useIntl();
  const keepRef = useRef<HTMLButtonElement>(null);
  useEffect(() => keepRef.current?.focus(), []);

  return (
    <div className={styles.scrim}>
      <div
        className={styles.dialog}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="viewer-confirm-title"
        aria-describedby="viewer-confirm-body"
      >
        <h3 id="viewer-confirm-title">{intl.formatMessage(viewerMessages.confirmTitle)}</h3>
        <p id="viewer-confirm-body">{intl.formatMessage(viewerMessages.confirmBody)}</p>
        <div className={styles.dialogButtons}>
          <button ref={keepRef} type="button" className={clsx(styles.btn, styles.btnGhost)} onClick={onKeep}>
            {intl.formatMessage(viewerMessages.confirmKeep)}
          </button>
          <button
            type="button"
            className={clsx(styles.btn, styles.btnDangerSolid)}
            disabled={isBusy}
            onClick={onTurnOff}
          >
            {intl.formatMessage(viewerMessages.confirmTurnOff)}
          </button>
        </div>
      </div>
    </div>
  );
};

export const ViewerConfirmDialog = TypedMemo(ViewerConfirmDialogComponent);
